<!-- Menu.svelte -->
<script>
  import ItemMenu from "./ItemMenu.svelte";
  import { ItemMenus } from "../Classes/ItemMenus.js";
  import Constantes from "../Classes/Constantes";
  import { Menu, Burger } from "@svelteuidev/core";
    import { onMount } from "svelte";

  export let menuOpen = false;
  let element;
  let opened;
  let menuElement;
  // Listas de nomes e ícones dos itens de menu
  let itens = [
    new ItemMenus({
      nome: "Menu principal",
      navegarPara: Constantes.tela_menu,
      icone: "fas fa-home",
      permissao: "",
      SoLogado: false,
    }),
    new ItemMenus({
      nome: "Assessorias",
      navegarPara: Constantes.tela_assessorias,
      icone: "fas fa-chalkboard-teacher",
      permissao: "",
      SoLogado: false,
    }),
    new ItemMenus({
      nome: "Anamnese",
      navegarPara: Constantes.tela_anamnese,
      icone: "fas fa-notes-medical",
      permissao: "poder_ver_anamnese",
      SoLogado: true,
    }),
    new ItemMenus({
      nome: "Relatórios",
      navegarPara: "/relatorios",
      icone: "fas fa-user",
      permissao: "pode_ver_relatorio",
      SoLogado: true,
    }),
    new ItemMenus({
      nome: "Prescrever treinos",
      navegarPara: Constantes.tela_cadastrar_treino_atleta,
      icone: "fas fa-clipboard-list",
      permissao: "pode_prescrever_treinos",
      SoLogado: false,
    }),
     new ItemMenus({
      nome: "Prescrever treinos com caledario",
      navegarPara: Constantes.tela_cadastrar_treino_atleta3,
      icone: "fas fa-clipboard-list",
      permissao: "pode_prescrever_treinos",
      SoLogado: true,
    }),

    new ItemMenus({
      nome: "Criar treino",
      navegarPara: Constantes.tela_exibe_lista_treinos,
      icone: "fas fa-tasks",
      permissao: "pode_criar_treino",
      SoLogado: true,
    }),
    new ItemMenus({
      nome: "Meu plano de treino",
      navegarPara: Constantes.tela_exibe_plano_corrida,
      icone: "fa-solid fa-person-running",
      permissao: "pode_ver_treinos",
      login: false,
    }),

    new ItemMenus({
      nome: "Meus atletas",
      navegarPara: Constantes.tela_do_atleta,
      icone: "fas fa-user-friends",
      permissao: "pode_ver_atletas",
      SoLogado: true,
    }),
     new ItemMenus({
            nome: "Calculadora de Zonas de treinamento",
            navegarPara: Constantes.tela_calcula_zona,
            icone: "fa fa-calculator",
            permissao:"",
            
        }),
         new ItemMenus({
            nome: "Calculadora de Velocidades/Paces",
            navegarPara: Constantes.tela_calcula_pace,
            icone: "fa fa-chart-line",
            permissao:"",
            
        }),
              new ItemMenus({
            nome: "Meu perfil",
            navegarPara: Constantes.tela_meu_cadastro,
            icone: "fa fa-id-badge",
            permissao:Constantes.pode_ver_meu_cadastro,
            SoLogado: true,
        }),
            new ItemMenus({
            nome: "Sobre",
            navegarPara: Constantes.tela_sobre,
            icone: "fa fa-info-circle",
            permissao:"",
           
        }),
    new ItemMenus({
      nome: "Configurações",
      navegarPara: Constantes.tela_menu_config,
      icone: "fa fa-cog",
      permissao: Constantes.pode_ver_configuracoes,
      SoLogado: true,
    }),
    new ItemMenus({
      nome: "Logout",
      navegarPara: "/",
      icone: "fas fa-lock",
      permissao: "",
      SoLogado: true,
      logout: true,
    }),
    new ItemMenus({
      nome: "Login",
      navegarPara: "/login2",
      icone: "fas fa-lock",
      permissao: "",

      login: true,
    }),
  ];
  // Função para detectar clique fora do menu
  function handleClickOutside(event) {
    if (menuOpen && menuElement && !menuElement.contains(event.target)) {
      menuOpen = false;
    }
  }

  // Adicionar o evento de clique fora ao montar o componente
  onMount(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  });
</script>
<div bind:this={menuElement}>
<Menu >
  <Burger
    slot="control"
    opened={menuOpen}
    on:click={() => {
      menuOpen = !menuOpen;
    }}
    color="#3f3f3f"
  />
  {#each itens as item, i}
    <ItemMenu {item} on:close={() => (menuOpen = false)} />
  {/each}
</Menu>
</div>
<style>
  .menu-modal {
    position: fixed;
    top: 56px; /* Altura do navbar */
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* Fundo escuro semi-transparente */
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 989; /* Garante que o menu está sobreposto a outros elementos */
    pointer-events: none; /* Permite clicar nos elementos abaixo do menu */
  }

  .menu-content {
    width: 100%; /* Ocupa toda a largura */
    max-width: 100%; /* Largura máxima do menu */
    background-color: white;
    border-bottom-left-radius: 20px; /* Cantos inferiores arredondados */
    border-bottom-right-radius: 20px; /* Cantos inferiores arredondados */
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5); /* Sombra */
    pointer-events: auto; /* Permite clicar dentro do menu */
  }

  /* Efeito de transição para suavizar a abertura e fechamento do menu */
  .menu-modal {
    transition: opacity 0.3s ease;
  }

  /* Ajuste de visibilidade do menu */
  .menu-modal.closed {
    opacity: 0;
    pointer-events: none; /* Impede cliques no menu fechado */
  }

  /* Estilize seus itens de menu conforme necessário */
  .menu-content ul {
    list-style-type: none;
    padding: 0;
  }

  .menu-content ul li {
    margin-bottom: 10px;
  }

  .menu-content ul li a {
    color: #333;
    text-decoration: none;
  }
</style>
